import { Chip, Progress, Text, Title } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";
import { MetricLabel } from "./MetricLabel";
import { type BreakdownRow, SCORE_MAX } from "./types";
import { formatScore } from "./utils";

export function BreakdownScoreRow({ row }: { row: BreakdownRow }) {
  const { t } = useTranslation();
  const percent = row.score === null ? 0 : (row.score / SCORE_MAX) * 100;

  return (
    <div className="flex w-full flex-col items-stretch gap-(--spacing-8) border-b border-outline-subtle px-(--spacing-8) py-(--spacing-10)">
      <div className="w-full">
        <div className="flex items-start justify-between gap-(--spacing-16)">
          <div className="flex min-w-0 flex-wrap items-center gap-(--spacing-12)">
            <Title size="md">{row.label}</Title>
            <Chip
              label={t("enterprise.facilityDetail.drawer.weightLabel", {
                weight: row.weight,
              })}
            />
          </div>
          <div className="shrink-0 text-right">
            <Title size="xl" as="span" tone={row.tone}>
              {row.score === null ? "—" : formatScore(row.score)}
            </Title>
            <Text as="span" size="sm" tone="subtle">
              /{SCORE_MAX}
            </Text>
          </div>
        </div>
      </div>
      <div className="w-full">
        <Progress
          value={percent}
          tone={row.tone}
          size="lg"
          aria-label={row.label}
        />
      </div>
      <div className="w-full">
        <div>
          <div className="flex flex-wrap gap-x-(--spacing-24) gap-y-(--spacing-4)">
            <MetricLabel
              label={t("enterprise.facilityDetail.drawer.currentLabel")}
              value={row.current}
            />
            <MetricLabel
              label={t("enterprise.facilityDetail.drawer.targetLabel")}
              value={row.target}
            />
          </div>
          <Text as="div" size="sm" tone="subtle">
            {row.description}
          </Text>
        </div>
      </div>
    </div>
  );
}
